import { render } from "./add_paroisse.vue?vue&type=template&id=a5747530&scoped=true"
import script from "./add_paroisse.vue?vue&type=script&lang=js"
export * from "./add_paroisse.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=a5747530&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5747530"]])

export default __exports__